import styled from 'styled-components';

export const Call2Actions = styled.div.attrs({
    className: 'home-call2actions',
})`
    figure {
        display: none;
    }
`;
